import React from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import { AnimatedText } from "../components/AnimatedComponents";
import "./Pages.css";

const Terms = () => (
  <Container>
    <Row>
      <AnimatedText>
        <h1 className="page-heading">Terms & Conditions</h1>
      </AnimatedText>
      <div className="page-text-container">
        <AnimatedText delay={150}>
          <div className="page-section">
            <p>
              Terms of Service for the use of the websites and mobile app services
              of Loyalties.
            </p>
          </div>
        </AnimatedText>

        <AnimatedText delay={300}>
          <div className="page-section">
            <p className="page-section-heading">General</p>
            <p>
              <strong>mmmh AG</strong> (hereinafter referred to as "Loyalties")
              provides software for mobile devices (hereinafter referred to as
              "App") that allows users to digitally collect, manage, and receive
              offers for loyalty programs.
            </p>
            <p>
              If contracts are concluded between users and Loyalties for the
              services provided by Loyalties,
            </p>
            <p>
              <strong>mmmh AG</strong>
            </p>
            <p>Fledhof 12</p>
            <p>6300 Zug</p>
            <p>Switzerland</p>
            <p>CHE-201.571.803 MWST</p>
            <p>Email: contact@mmmh.studio</p>
            <p>is the contracting party.</p>
            <p>
              These terms of use form the basis of the legal relationship between
              Loyalties and users of services provided via Loyalties websites or
              mobile services for mobile devices (phone, smartphone, PDA, etc.)
              after downloading (hereinafter referred to as Loyalties services).
            </p>
          </div>
        </AnimatedText>

        <div className="page-section">
          <p className="page-section-heading">1. Scope</p>
          <p>
            These terms of use apply exclusively. They also apply in the event
            of conflicting terms and conditions of users. They will not be
            accepted even if Loyalties provides services with knowledge of a
            user's conditions, unless otherwise agreed in writing.
          </p>
        </div>

        <div className="page-section">
          <p className="page-section-heading">
            2. Service / Contractual Relationships
          </p>
          <p>
            (1) Users can use Loyalties services after downloading the Loyalties
            software (App) on mobile devices. Loyalties services are free for
            private users.
          </p>
          <p>
            (2) Loyalties services allow users to use their a digitally
            generated barcode on their mobile device to participate in offers
            provided by its partners. In addition, users of Loyalties services
            can obtain information about current offers from participating
            businesses via the Loyalties app. Loyalties does not provide any
            warranty or liability for the accuracy of the offers.
          </p>
        </div>

        <div className="page-section">
          <p className="page-section-heading">3. Registration</p>
          <p>
            (1) Parts of the App may require the respective user to register
            properly. Registering multiple user accounts is permissible; user
            accounts are not transferable.
          </p>
          <p>
            (2) Loyalties may reject the registration if there is a valid
            reason, e.g., the user provides incorrect information.
          </p>
          <p>
            (3) The data requested during registration must be complete and
            correct. If this information changes after registration, the user is
            obliged to promptly correct the details in the user account.
          </p>
          <p>
            (4) Loyalties reserves the right to delete user accounts if
            registrations are not completed fully after a reasonable period.
          </p>
        </div>

        <div className="page-section">
          <p className="page-section-heading">4. Usage Rights to the App</p>
          <p>
            (1) The user receives simple (non-sublicensable and
            non-transferable) usage rights to the App for the duration of this
            agreement, subject to the following provisions.
          </p>
          <p>
            (2) The App is not provided to the user. The user may only use the
            App for their own activities.
          </p>
          <p>
            (3) The user is not authorized to make changes to the App. This does
            not apply to changes necessary to correct errors, provided Loyalties
            is in default with rectifying the error or refuses rectification
            after written request.
          </p>
          <p>
            (4) If Loyalties releases new versions, updates, upgrades, or other
            new deliveries of the App during the term, the above rights also
            apply to these.
          </p>
          <p>
            (5) Rights not expressly granted to the user above are not granted
            to the user. In particular, the user is not authorized to use the
            App beyond the agreed use, or to allow third parties to use or make
            the App accessible to third parties. In particular, it is not
            permitted to reproduce, sell, or temporarily transfer the App,
            especially not to rent or lend it. Users are also not entitled to
            allow third parties to use Loyalties's services for a fee, unless
            Loyalties has expressly approved such transfer in writing
            beforehand.
          </p>
        </div>

        <div className="page-section">
          <p className="page-section-heading">
            5. Limited Liability / Availability
          </p>
          <p>
            (1) Loyalties also grants users access to information provided by
            third parties through its services. The third parties themselves are
            responsible for this information. Loyalties does not provide any
            warranty or liability for the content of third parties, in
            particular not for the accuracy of price and product information,
            the availability of products, and the completeness of the
            information.
          </p>
          <p>
            (2) Loyalties is generally only liable to users for damages due to
            contractual and non-contractual claims in case of intent and gross
            negligence. In the event of a breach of material contractual
            obligations, in the event of default by the debtor, and in the event
            of impossibility of performance for which Loyalties is responsible,
            Loyalties is also liable for any negligent breach of duty by its
            employees and vicarious agents. Except in cases of intent/gross
            negligence by Loyalties and grossly negligent behavior by its legal
            representatives, employees, or vicarious agents, liability is
            limited to the typically foreseeable damage. To the extent that
            Loyalties's liability is excluded or limited, this also applies to
            the liability of its legal representatives, employees, or vicarious
            agents.
          </p>
          <p>
            (3) The above limitations of liability do not apply to damages
            resulting from injury to life, body, or health, as well as in the
            event of mandatory legal regulations and material contractual
            obligations.
          </p>
          <p>
            (4) Loyalties reserves the right to change or supplement these
            conditions at any time, without informing users in advance, to the
            extent necessary to maintain their effectiveness and legality due to
            corresponding changes in legislation or significant changes in case
            law, or in the course of expanding areas and technical
            circumstances, or to cover newly integrated functions. Loyalties
            reserves the right to change or supplement these terms of use for
            the future. Users have no claim to the temporal and/or spatial
            availability of Loyalties services; there is no entitlement to
            download the App. Loyalties services may be restricted, interrupted,
            or discontinued without notice to users. In particular, Loyalties
            does not guarantee the general functionality of the scanning
            process.
          </p>
          <p>
            (5) Loyalties also does not guarantee that the App meets the
            specific requirements of the user or is suitable for a specific
            purpose, unless expressly confirmed.
          </p>
          <p>
            (6) Users are obliged to lawfully use Loyalties services. Loyalties
            services may not be misused, in particular, to disseminate
            criminally relevant content or to violate the rights of third
            parties (including industrial property rights and competition law).
            Activities of this nature may lead to civil or criminal prosecution.
          </p>
          <p>
            (7) Users are responsible for all content (e.g., images, texts, and
            links) they make accessible or distribute to others. It is therefore
            the responsibility of each user to ensure that all content is lawful
            and does not infringe on the rights of third parties.
          </p>
          <p>
            (8) Before uploading image files, users must ensure that they have
            usage rights to the image or corresponding file and that publication
            complies with legal regulations, the rights of third parties, and
            good morals. Users must take appropriate precautions to additionally
            secure information made accessible by them on Loyalties services to
            third parties. Loyalties is not liable, in particular, for the loss
            of user data.
          </p>
          <p>
            (9) The Loyalties app may only be used by users for private
            purposes. Data uses intended to use content commercially,
            professionally, or otherwise in a business-like manner are
            prohibited for users.
          </p>
          <p>
            (10) Users indemnify Loyalties against any claims by third parties
            that are raised due to their fault due to illegal use of Loyalties
            services. Users promptly notify Loyalties of any claims by third
            parties due to illegal use.
          </p>
          <p>
            (11) The user is responsible for the use and security of their
            loyalty cards. The user is liable for all transactions on the card,
            except in cases of negligent behavior by Loyalties. The user is
            responsible for protecting the card and ensuring that no one can see
            or record the information of the loyalty card. Loyalties strongly
            recommends that all users set a secure password on their mobile
            device.
          </p>
        </div>

        <div className="page-section">
          <p className="page-section-heading">6. Privacy</p>
          <p>
            The collection, storage, and processing of personal data are
            governed by the separate privacy policy.
          </p>
        </div>

        <div className="page-section">
          <p className="page-section-heading">
            7. Limited Liability for Unlawful Third-Party Content
          </p>
          <p>
            (1) As a provider of a telemedium, Loyalties is not obligated to
            monitor the information of third parties on Loyalties services or to
            investigate circumstances that indicate illegal activities.
          </p>
          <p>
            (2) Once Loyalties becomes aware that users are engaging in illegal
            activities on Loyalties services or that illegal data and false
            consumer information are present on the services, the relevant data
            will be promptly removed, access to it will be blocked, and the
            corresponding users may be blocked.
          </p>
          <p>
            (3) Loyalties may also alert users to third-party content and
            applications via links. If and to the extent that the conclusion of
            a contract is offered in connection with this third-party content,
            it is concluded exclusively with the party designated as the
            provider and the user upon conclusion thereof. Loyalties will not be
            a contracting party.
          </p>
          <p>
            (4) Insofar as Loyalties websites contain links to other websites,
            these were checked for their legality at the time the link was set.
            At the time of setting the link, no illegal content was discernible
            on the linked websites. However, it is not possible to exert
            influence on the content of linked pages of other companies. Nor is
            it possible to ensure ongoing editorial control of linked external
            pages. Insofar as Loyalties becomes aware of illegal content on
            linked external pages, the corresponding links will be promptly
            removed. If users detect or suspect that there are contents on
            Loyalties services that violate these terms and conditions or are
            unlawful, Loyalties asks for the violation to be reported.
          </p>
        </div>

        <div className="page-section">
          <p className="page-section-heading">10. Term and Termination</p>
          <p>
            (1) The term of the usage relationship begins with the conclusion of
            the contract and is concluded for an indefinite period. The
            provision of services begins from the start of the term.
          </p>
          <p>
            (2) The contractual relationship can be terminated by either party
            with a notice period of 10 days.
          </p>
          <p>
            (3) Notwithstanding the above provisions, Loyalties may terminate
            the contract without notice if there is good cause. Important
            reasons include, in particular, the following events:
          </p>
          <p>(3.1) Failure by the user to comply with legal regulations,</p>
          <p>(3.2) Serious breach of these terms and conditions by the user.</p>
        </div>

        <div className="page-section">
          <p className="page-section-heading">11. Final Provisions</p>
          <p>
            (1) These terms and conditions are subject to the law of the Swiss
            Confederation. The choice of law applies to users who are consumers
            only insofar as the protection granted by mandatory provisions of
            the law of the country in which the user has his habitual residence
            is not withdrawn.
          </p>
          <p>
            (2) Should one or more provisions of this agreement be or become
            invalid, the validity of the agreement shall otherwise not be
            affected.
          </p>
        </div>
      </div>
    </Row>
  </Container>
);

export default Terms;
